// extracted by mini-css-extract-plugin
export default {"shareModalWrap":"ShareTourModal_shareModalWrap__XxmWi"};